<template>
    <div class="CSChatThai" style="background: white;height: 100vh;justify-content: center;display: flex;">
<!--   {{progress}} -->
  <v-progress-circular
        :size="80"
        color="primary"
        indeterminate
        v-if="progress"
        style="margin: auto;"
      ></v-progress-circular>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Encode } from '@/services'


export default {
  data: () => ({
    progress: true
    // AUTH: ''
  }),
  computed: {
    ...sync('*')
  },
  created () {
    // localStorage.setItem('user_id', Encode.encodeToken('eeb8855b-b330-4bc5-a1d1-e7f3c3350277'))
    // this.user_id = Decode.decodeToken(this.$session.get('user_id'))
    // this.AUTH = this.$route.query.authorization
    // console.log(this.AUTH)
    this.getUserData()
  },
  methods: {
    getUserData() {
    	var reqestBody = {onemail_token_encrypt: this.$route.query.onemail_token_encrypt, mail_encrypt: this.$route.query.mail_encrypt}
    	// console.log(this.AUTH)
    	// console.log(reqestBody)
      this.axios.post(process.env.VUE_APP_API + '/getUserData', reqestBody).then((response) => {
      	// console.log(response)
      	// localStorage.setItem('auth_token', Encode.encodeToken(response.data.data.auth_token))
      	if (response.status === 200) {
      		localStorage.setItem('auth_token', Encode.encodeToken(response.data.data.auth_token))
      		localStorage.setItem('onemail_token', Encode.encodeToken(response.data.data.onemail_token))
	      	localStorage.setItem('user_id', Encode.encodeToken(response.data.data.user_id))
	      	localStorage.setItem('display_name', response.data.data.display_name)
	      	localStorage.setItem('email', response.data.data.email)
	      	this.progress = false
	      	this.$router.push('/list_room')
      	} else {
      		console.error('not found')
      	}
      }).catch((error) => {
        console.log(error.message)
      })
    }
  }
} 
</script>
<style type="text/css" scoped>
.CSChatThai {
 /*font-family: 'CS ChatThaiUI' !important;*/
 word-wrap: break-word;
}
>>>.v-text-field--outline input {
    margin: auto !important;
    margin-top: auto !important;
}
>>>.v-text-field--outline>.v-input__control>.v-input__slot {
    /*background: white !important;
    border-radius: 10px !important;*/
    background: #3978c7 !important;
    border-radius: 38px !important;
    }
.colorAvatar {
  color: #2562af !important;
}
.timeListChat {
  color: #adadad;
  font-size: 10px;
}
>>>.theme--light.v-text-field--outline>.v-input__control>.v-input__slot {
  border: 0 !important;
}

>>>.v-badge--bottom .v-badge__badge {
    /*bottom: -8px !important;*/
    bottom: -5px !important;
}
>>>.v-badge__badge {
  height: 10px !important;
  width: 10px !important;
  right: -14px !important;
}
>>>.v-list--two-line .v-list__tile {
  height: 65px !important;
}
.v-text-field--box .v-input__slot, .v-text-field--outline .v-input__slot {
  height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/mail/check_authen.vue